import React from "react";
import ConversationListItem from "../conversationListItem/conversationListItem";
import "./conversatiolist.css";
import { chatSelector } from "../../../../../store/selector";
import { connect } from "react-redux";
import EmptyConversation from "./EmptyConversation";
function ConversationList({
  conversationList,
  showAssignButton,
  // disposeCustomer,
  canSelectCustomer,
  setAssignScreen,
  assignScreen,
  disposeList
}) {
  // if (!conversationList || conversationList.length === 0) {
  //   return <EmptyConversation assignScreen={assignScreen} key={assignScreen} />;
  // }
  if ((!conversationList || conversationList.length === 0) && (!disposeList || disposeList.length === 0)) {
    return <EmptyConversation assignScreen={assignScreen} key={assignScreen} />;
  }
  const combinedList = [
    ...(conversationList || []), // Default to empty array if undefined
    ...(disposeList || []),
  ];
  // return conversationList.map((e) => {
  //   console.log("e112233", e);
  //   if (e && e.customer) {
  //     return (
  //       <ConversationListItem
  //         setAssignScreen={setAssignScreen}
  //         showAssignButton={showAssignButton}
  //         disposeCustomer={disposeCustomer}
  //         canSelectCustomer={canSelectCustomer}
  //         key={e.customer && e.customer.display}
  //         listData={e}
  //         conversationList={conversationList}
  //         disposeList={disposeList}
  //       />
  //     );
  //   } else {
  //     return null;
  //   }
  // });

  const renderItems = (list, isDisposeItem) =>
    list && list.map((e, index) => (
      e && e.customer && (
        <ConversationListItem
          key={`${isDisposeItem ? "dispose" : "conversation"}-${index}`}
          setAssignScreen={setAssignScreen}
          showAssignButton={showAssignButton}
          disposeCustomer={isDisposeItem ? true : false}
          canSelectCustomer={canSelectCustomer}
          listData={e}
          isDisposeItem={isDisposeItem} // Pass the flag
        />
      )
    ));

  return (
    <span>
      {renderItems(conversationList, false)} {/* For conversationList */}
      {renderItems(disposeList, true)} {/* For disposeList */}
    </span>
  );
  // return combinedList.map((e, index) => {
  //   console.log("Item from combinedList:", e);
  //   if (e && e.customer) {
  //     return (
  //       <ConversationListItem
  //         setAssignScreen={setAssignScreen}
  //         showAssignButton={showAssignButton}
  //         disposeCustomer={disposeCustomer}
  //         canSelectCustomer={canSelectCustomer}
  //         key={`${e.customer.display}-${index}`} // Ensure unique keys
  //         listData={e}
  //         conversationList={conversationList}
  //         disposeList={disposeList}
  //       />
  //     );
  //   } else {
  //     return null;
  //   }
  // });
}

const stateToProps = (state) => ({
  assignScreen: chatSelector.getChatDynamic(state, "details.assignScreen"),
});

export default connect(stateToProps)(ConversationList);



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/ConversationList/index.js